import { render } from "./ClockHead.vue?vue&type=template&id=a158af8e&scoped=true"
import script from "./ClockHead.vue?vue&type=script&lang=js"
export * from "./ClockHead.vue?vue&type=script&lang=js"

import "./ClockHead.vue?vue&type=style&index=0&id=a158af8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a158af8e"]])

export default __exports__